import React, { useState, useEffect, useRef, useContext } from 'react';
import { LegacyStack, InlineError } from '@shopify/polaris';
import { FormContext, Util, api } from '@thinkwell/react.common'
import { Spinner, Form } from '@thinkwell/react.polaris'

export default function ProxyForm(props) {
  const form = useContext(FormContext)
  const formRef = useRef();
  const [submitting, setSubmitting] = useState(false);
  const [proxySubmitting, setProxySubmitting] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(0);
  const [submitError, setSubmitError] = useState(props.error);
  const url = props.proxy.url || `https://${props.proxy.host}${props.proxy.action}?shop_name=${props.proxy.shop_name}`
  const submitRef = props.submitRef || useRef(null);

  const onSuccess = (response) => {
    setProxySubmitting(false)
    props.onSuccess && props.onSuccess(response)
  }

  const onError = (error) => {
    setProxySubmitting(false)
    let errorMessage = error.message || error
    if (error.response && error.response.status == 429) {
     errorMessage = "You've made too many password reset attempts. Please try again later or contact support@thinkwell.com."
    }
    setSubmitError(errorMessage)
    props.onError && props.onError(error)
  }

  const onProxySuccess = (response) => {
    if (response.data) {
      for(var name in response.data) {
        var existingInput = formRef.current.elements[name]
        if(existingInput) {
          existingInput.setAttribute("disabled", "")
        }
        var input = document.createElement('input');
        input.type = 'hidden';
        input.id = `${name}_hidden`
        input.name = name;
        input.value = response.data[name];
        formRef.current.appendChild(input);
      }
    }
    setProxySubmitting(true)
    // send via XHR
    if (props.xhr) {
      const formData = form.data
      return api({method: 'post', url: props.action, data: formData})
      .then(onSuccess)
      .catch(onError)
    } else {
      formRef.current.submit();
    }
  }

  const onClick = (event) => {
    event.preventDefault();
    setSubmitClicked(submitClicked + 1);
    const errors = form.errors
    if(!errors.length) {
      submitRef.current();
    } else {
      console.error(errors)
    }
  }

  return (<div>
      { !!submitClicked && form.errors.length ?
        <InlineError message={(<div> {form.errors.map((error) => (<div className="validation-error" key={error}>{error}</div>)) } </div>)} fieldID="contactFormErrorFieldID" />
      : null }
      { submitError ?
        <InlineError message={submitError} fieldID="loginErrorFieldID" />
      : null }
      <Form style={{display: 'none'}}
        submitRef={submitRef}
        method="post"
        url={url}
        onSuccess={onProxySuccess}
        onError={onError}
        onSubmitting={setSubmitting}
      >
      </Form>
      <form method="post" action={props.action} acceptCharset="UTF-8" ref={formRef} className="form">
        <input readOnly type="hidden" name="utf8" value="✓" />
        {props.children}
        <div style={{marginTop: '15px'}} className="action_bottom">
          <Spinner active={proxySubmitting || submitting}>
            <input className="button" type="submit" value={props.submitText} onClick={onClick} disabled={!!(submitting || proxySubmitting)} />
          </Spinner>
          { props.bottomLink ?
            <span className="note"><a style={{marginLeft: '15px'}} href={props.bottomLink.href} onClick={props.bottomLink.onClick}>{props.bottomLink.text}</a></span>
            : null
          }
        </div>
      </form>
    </div>)
}
